import circleUserIcon from "@core/assets/icons/circle-user.svg?raw";
import pinIcon from "@core/assets/icons/pin.svg?raw";
import todoIcon from "@core/assets/icons/todo.svg?raw";
import { Locale } from "@core/schema/Locale.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getAccountDetailsPath } from "@core/schema/paths/getAccountDetailsPath.js";
import { getCustomerAddressesPath } from "@core/schema/paths/getCustomerAddressesPath.js";
import { getOrderListingPath } from "@core/schema/paths/getOrderListingPath.js";

export function getAuthMenuItems(tenant: Tenant): { name: string; href: string; icon: string }[] {
	return [
		{
			href: getOrderListingPath(tenant),
			name: {
				[Locale.cs]: "Objednávky",
				[Locale.en]: "Orders",
			}[tenant.locale],
			icon: todoIcon,
		},
		{
			href: getCustomerAddressesPath(tenant),
			name: {
				[Locale.cs]: "Adresy",
				[Locale.en]: "Addresses",
			}[tenant.locale],
			icon: pinIcon,
		},
		{
			href: getAccountDetailsPath(tenant),
			name: {
				[Locale.cs]: "Detaily účtu",
				[Locale.en]: "Account Details",
			}[tenant.locale],
			icon: circleUserIcon,
		},
	];
}
